import { useEffect, useState } from 'react'

export default function useUpdateBalance(
  balance: string,
  betInfoBalance: string,
) {
  const [finalbalance, setfinalBalance] = useState<string>(balance)

  useEffect(() => {
    setfinalBalance(balance)
  }, [balance])

  useEffect(() => {
    setfinalBalance(betInfoBalance)
  }, [betInfoBalance])

  return finalbalance
}
